import DefaultRouter from "./routers/DefaultRouter";

function App() {
  return (
    <DefaultRouter/>
  );
}

export default App;
